module.exports = __webpack_public_path__ + "img/service-sem-2.42f545c9.png";